import { render } from "./App.vue?vue&type=template&id=2f36539c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2f36539c&lang=scss"
script.render = render

export default script